__turbopack_context__.v({
  "Content": "TagsInput-module-scss-module__lMj6aG__Content",
  "addButton": "TagsInput-module-scss-module__lMj6aG__addButton",
  "badge": "TagsInput-module-scss-module__lMj6aG__badge",
  "disabled": "TagsInput-module-scss-module__lMj6aG__disabled",
  "header": "TagsInput-module-scss-module__lMj6aG__header",
  "hidePlaceholder": "TagsInput-module-scss-module__lMj6aG__hidePlaceholder",
  "hint": "TagsInput-module-scss-module__lMj6aG__hint",
  "input": "TagsInput-module-scss-module__lMj6aG__input",
  "inputContent": "TagsInput-module-scss-module__lMj6aG__inputContent",
  "inputLabel": "TagsInput-module-scss-module__lMj6aG__inputLabel",
  "required": "TagsInput-module-scss-module__lMj6aG__required",
  "root": "TagsInput-module-scss-module__lMj6aG__root",
  "row": "TagsInput-module-scss-module__lMj6aG__row",
  "secondary": "TagsInput-module-scss-module__lMj6aG__secondary",
  "selectedList": "TagsInput-module-scss-module__lMj6aG__selectedList",
  "textInput": "TagsInput-module-scss-module__lMj6aG__textInput",
  "title": "TagsInput-module-scss-module__lMj6aG__title",
  "warning": "TagsInput-module-scss-module__lMj6aG__warning",
});
